export const enum KnxApp {
    Unspecified = 'Unspecified',
    All = 'All',
    FreightBoxAssetTracker = 'FreightBoxAssetTracker',
    FreightBoxTrailerSolutions = 'FreightBoxTrailerSolutions',
}
